import PropTypes from 'prop-types';

const TitleFooter = ({ answers, createdDatetime, fastTrackName }) => {
  if (!fastTrackName) return null;

  const type = `Narrative Type: ${fastTrackName}`;
  const createdOn = createdDatetime ? ` | Created: ${createdDatetime}` : '';

  const subscribedChannels = answers?.subscribedChannels?.length
    ? answers.subscribedChannels.map((channel) => channel?.name)
    : [];

  return (
    <div>
      <p>
        <small>
          {type}
          {createdOn}
        </small>
      </p>
      {subscribedChannels.length > 0 && (
        <p>
          <small>Subscribed Channels: {subscribedChannels.join(', ')}</small>
        </p>
      )}
    </div>
  );
};

TitleFooter.propTypes = {
  answers: PropTypes.object,
  createdDatetime: PropTypes.string,
  fastTrackName: PropTypes.string,
};

export default TitleFooter;
